/* eslint-disable react/forbid-prop-types */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

class GlobalEventDiv extends React.Component {
	constructor(props) {
		super(props);
		this.divRef = React.createRef();
		this.listeners = {};
	}

	componentDidMount() {
		const { events, triggerOnMount } = this.props;
		events.forEach((type) => {
			this.listeners[type] = (ev) => this.trigger(ev);
			window.addEventListener('resize', this.listeners[type]);
		});
		if (triggerOnMount) {
			this.trigger({ type: 'mount' });
		}
	}

	componentDidUpdate() {
		const { triggerOnUpdate } = this.props;
		if (triggerOnUpdate) {
			this.trigger({ type: 'update' });
		}
	}

	componentWillUnmount() {
		const { triggerOnUnmount } = this.props;
		_.entries(this.listeners).forEach(([type, listener]) => (
			window.removeEventListener(type, listener)
		));
		if (triggerOnUnmount) {
			this.trigger({ type: 'unmount' });
		}
	}

	trigger(ev) {
		const { current } = this.divRef;
		const { callback } = this.props;
		if (current) {
			callback(current, ev);
		}
	}

	render() {
		const { children } = this.props;
		const childProps = _.omit(this.props, _.keys(GlobalEventDiv.propTypes));
		return (
			<div {...childProps} ref={this.divRef}>
				{children}
			</div>
		);
	}
}

GlobalEventDiv.propTypes = {
	events: PropTypes.arrayOf(PropTypes.string),
	callback: PropTypes.func.isRequired,
	children: PropTypes.any,
	triggerOnUpdate: PropTypes.bool,
	triggerOnMount: PropTypes.bool,
	triggerOnUnmount: PropTypes.bool,
};

GlobalEventDiv.defaultProps = {
	events: ['resize'],
	children: undefined,
	triggerOnUpdate: true,
	triggerOnMount: true,
	triggerOnUnmount: false,
};

export default GlobalEventDiv;
